/**
 * Format code using Monaco Editor's built-in formatter
 * @param {object} editor - Monaco Editor instance
 * @param {object} monaco - Monaco namespace
 * @returns {Promise<boolean>} Success status
 */
export const formatCode = async (editor, monaco) => {
  try {
    console.log("Attempting to format code...");
    const model = editor.getModel();
    const language = model.getLanguageId();
    console.log(`Current language: ${language}`);

    const action = editor.getAction("editor.action.formatDocument");
    if (action) {
      console.log("Format action found, running...");
      await action.run();
      console.log("Format action completed");
      return true;
    } else {
      console.warn("Format action not found");
      return false;
    }
  } catch (error) {
    console.warn("Formatting failed:", error);
    return false;
  }
};

/**
 * Format selected code using Monaco Editor's built-in formatter
 * @param {object} editor - Monaco Editor instance
 * @param {object} monaco - Monaco namespace
 * @returns {Promise<boolean>} Success status
 */
export const formatSelection = async (editor, monaco) => {
  try {
    const action = editor.getAction("editor.action.formatSelection");
    if (action) {
      await action.run();
      return true;
    }
    return false;
  } catch (error) {
    console.warn("Selection formatting failed:", error);
    return false;
  }
};
